<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene1',
  mixins: [ SceneMixin ],

  beforeDestroy() {

    console.log('beforeDestroy');

    _.each(this.$sprites, (sp, index)=>{
      this.$els[index]['container'].removeChild(sp)
    })

    this.$column_container.filters = null

    this.$intro_front.kill()
    this.$sub1.kill()
    this.$sub2.kill()
    this.$sub3.kill()

    this.$container.removeChild(this.$scene)
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false

    this.$container.addChild(this.$scene)
    this.$parent.$scene1 = this.$scene

    const front_container = new Container()
    this.$scene.addChild(front_container)
    this.setCenterContainer(front_container)

    this.$column_container = new Container()
    this.$scene.addChild(this.$column_container)
    this.setCenterContainer(this.$column_container)
    
    this.$background = this.$column_container

    this.$intro_front = new TimelineMax()
    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()
    this.$sub3 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    const els = {

      'hall': { container: this.$column_container, alpha: 0, position: { x: 491, y: 1353, width: 572, height: 383 }},
      'shapes_bkg': { container: this.$column_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }, scale: this.$root.$scale*0.96 },

      'floor': { container: this.$column_container, alpha: 0, position: { x: 0, y: 1692, width: 1536, height: 468 } },
      'details_center': { container: this.$column_container, alpha: 0, position: { x: 465, y: 977, width: 641, height: 724 }},
      'details_side': { container: this.$column_container, alpha: 0, position: { x: 0, y: 548, width: 1536, height: 1276 }},
      'plafond': { container: this.$column_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 722 }},

      'light': { container: this.$column_container, alpha: 0 },
      'column': { container: this.$column_container, alpha: 0 },
      'column_details': { container: this.$column_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'column_details_mask': { container: this.$column_container, alpha: 0, position: { x: 0, y: 0, width: 1536, height: 2160 }},
      'bg_intro': { container: front_container, alpha: 1 },

      'sky': { container: front_container, alpha: 1, y: -50, position: { x: 0, y: 512, width: 1536, height: 1158 } },
      'clouds': { container: front_container, alpha: 1, position: { x: 0, y: 700, width: 1536, height: 900 }},
      'front': { container: front_container, alpha: 1,  position: { x: 0, y: 651, width: 1536, height: 939 }},
      'border': { container: front_container, alpha: 1, position: { x: 0, y: 1600, width: 1536, height: 560 } },

      'medium': { container: front_container, alpha: 0, scale: this.$root.$scale*0.18, x: 1.7, y: 194, anchor: { x: 0.5, y: 0.5 }, position: { x: 0, y: 0, width: 1536, height: 2160 } },
      'large': { container: front_container, alpha: 0, scale: this.$root.$scale*0.076, x: 1.6, y: 218, anchor: { x: 0.5, y: 0.5 }, position: { x: 0, y: 0, width: 1536, height: 2160 } },
      'flag1': { container: front_container, alpha: 1, position: { x: 755, y: 598, width: 61, height: 84 }},
      'flag2': { container: front_container, alpha: 0, position: { x: 755, y: 598, width: 61, height: 84 } },
      'flag3': { container: front_container, alpha: 0, position: { x: 755, y: 598, width: 61, height: 84 } },
    }

    this.$els = els

    _.each(els, (el, name)=>{
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.x -= this.$canvas_width/2
            sprite.y -= this.$canvas_height/2
            sprite.alpha = el.alpha
      el.container.addChild(sprite)
      sprites[name] = sprite
      this.applySettings(sprite, el)
    })

    // ******************************************************** //
    // ******************************************************** //

    const tempo = 2
    const alphaFilter = new PIXI.filters.AlphaFilter(1.0)
    this.$column_container.filters = [ alphaFilter ]

    const flag_motion = new TimelineMax({ repeat: -1 })
          .add([
              TweenMax.to(sprites['flag2'], tempo*0.2, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
              TweenMax.to(sprites['flag1'], tempo*0.2, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
          ])
          .add([
              TweenMax.to(sprites['flag3'], tempo*0.2, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
              TweenMax.to(sprites['flag2'], tempo*0.2, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
          ])
          .add([
              TweenMax.to(sprites['flag1'], tempo*0.2, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
              TweenMax.to(sprites['flag3'], tempo*0.2, { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
          ])

    const d1 = 16
    this.$intro_front
      .set(sprites['column_details'], { pixi: { scale: this.$root.$scale*0.75, y: '+=60' }})
      .set(sprites['column_details_mask'], { pixi: { scale: this.$root.$scale*0.1, y: '+=200' }})
      .add([
        TweenMax.to(front_container, d1, { pixi:{ scale: 54, x: '-=52', y: '-=12400' }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['clouds'], d1*.755, { pixi:{ y: '-=200' }, ease: Cubic.easeOut }),
        TweenMax.to(sprites['border'], d1*0.25, { pixi:{ y: '+=50' }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['medium'], 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: d1*0.44 }),
        TweenMax.to(sprites['large'], 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: d1*0.60 }),
        TweenMax.to(sprites['column_details'], d1*0.15, { pixi: { scale: this.$root.$scale*1, y: '-=60', alpha: 1 }, ease: Linear.easeNone, delay: d1*0.85 }),
      ])

    const pillar = new TimelineMax({})
          .add([
            TweenMax.to(sprites['column_details_mask'], d1*.25, { pixi: { alpha: 1 }, ease: Linear.easeNone, delay: d1*.25 }),
            TweenMax.to(sprites['column_details_mask'], d1*.5, { pixi: { scale: this.$root.$scale*1, y: '-=200' }, ease: Linear.easeNone, delay: d1*.5 })
          ])

    const d2 = 6 
    this.$sub1
      .add([
        TweenMax.to(front_container, d2*(2/12), { pixi:{ alpha: 0 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['column'], d2*(2/12), { pixi:{ alpha: 1 }, ease: Linear.easeNone }, '-='+ .25),
      ])
      .to(sprites['shapes_bkg'], d2*(1/12), { pixi:{ alpha: 1, scale: this.$root.$scale*1 }, ease: Linear.easeNone }, '-='+ .25)
      .to(sprites['plafond'], tempo, { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['light'], d2*(1/12), { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['floor'], d2*(4/12), { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      ])
      .to(sprites['details_center'], d2*(1/12), { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      .add([
        TweenMax.to(sprites['details_side'], 1, { pixi:{ alpha: 1 }, ease: Linear.easeNone }),
        TweenMax.to(sprites['hall'], d2*(4/12), { pixi:{ alpha: 1 }, ease: Linear.easeNone })
      ])

    const d3 = 13
    this.$sub2
      .to(this.$column_container, d3*.25, { pixi: { scale: 1.15 }})
      .add([
        TweenMax.to(this.$column_container, d3*.75, { pixi: { scale: 2.00, y: 0, ease: Linear.easeNone }}),
        TweenMax.to(sprites['floor'], d3*.75, { pixi:{ y: '+=35' }, ease: Linear.easeNone }),
        TweenMax.to(sprites['column'], d3*.75, { pixi:{ y: '+=35' }, ease: Linear.easeNone }),
        TweenMax.to(sprites['column_details'], d3*.75, { pixi:{ y: '+=35' }, ease: Linear.easeNone }),
      ])

    this.$sub3
    
      // .set({}, { delay: this.$sub2.duration()*0.80 })
      // .add([
      //   TweenMax.to(sprites['column'], this.$sub2.duration()*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
      //   TweenMax.to(sprites['column_details'], this.$sub2.duration()*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
      //   TweenMax.to(sprites['column_details_mask'], this.$sub2.duration()*0.05, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
      // ])
      // .add([
      //   // TweenMax.to(sprites['floor'], this.$sub2.duration()*0.10, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }, '-='+ this.$sub2.duration()*0.15),
      // ])

      .add([
        TweenMax.to(sprites['column'], .75, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
        TweenMax.to(sprites['column_details'], .75, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
        TweenMax.to(sprites['column_details_mask'], .75, { pixi:{ alpha: 0 }, ease: Linear.easeNone, overwrite: false }),
        TweenMax.to(alphaFilter, 1, { alpha: 0, ease: Linear.easeNone })

      ])

    this.$tl.add([ this.$intro_front, pillar ], 0)
    this.$tl.add([ this.$sub1, this.$sub2 ], 16)
    this.$tl.add(this.$sub3, 28)

  },
  mounted() {
    // this.chapter.$tl.play(20)
  }
}
</script>























